// extracted by mini-css-extract-plugin
export default {"change-host":"styles_change-host__6rZRr","form-reschedule__input":"styles_form-reschedule__input__h-2xo"};